import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { Modal, ModalControls } from '../../../components/Modal';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { EditSquare } from '../../../components/Icon';
import { Button } from '../../../components/Buttons';
import { ProductSelection } from './ProductSelection';
import { Input } from '../../../components/Input';
import { FormField } from '../../../components/FormFields';
import { addInvoiceSubject, calculateFinancialAmounts, updateInvoiceSubject } from '../../Invoices/actions';
import {
  DEFAULT_VAT_CODE,
  INVOICE_DIRECTIONS,
  INVOICE_SUBJECT_TYPES,
  REQUEST_ADD_INVOICE_SUBJECT,
} from '../../Invoices/constants';
import { selectWork } from '../../Api/selectors';
import { Loader } from '../../../components/Loader';
import { stringToNumber } from '../../Shared/helpers/general';
import { fixPriceFormat, getQuantOfDecimalPlaces } from '../../../utils/string';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { ProductAndCostsModal } from '../../Invoices/components/ProductsAndCostsModal';
import {ProductDefaultTasksModalConfirmation} from "./productDefaultTasksModal";

const Wrap = styled.div`
  width: 100%;
  .basic-multi-select {
    width: 100%;
  }
`;

const STATE = {
  disableSave: false,
  initiate: true,
  showDefaultTasksModal: false,
  applyDefaultTasks: false,
};

export class ProductSubjectDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.setState(
      prev => ({
        ...prev,
        ...(this.props.currentSubject ?? {}),
      }),
      () => {
        this.calculateVatRate();
      },
    );
  }

  calculateVatRate() {
    const priceExclVatPerItem = parseFloat(this.state.product_price_excl_vat_per_item) || 0;
    const priceInclVatPerItem = parseFloat(this.state.product_price_incl_vat_per_item) || 0;

    const vatRate = priceExclVatPerItem > 0 ? ((priceInclVatPerItem - priceExclVatPerItem) / priceExclVatPerItem) * 100 : 0;

    this.setState({ vatRate });
  }

  getFieldValue(name) {
    return this.state[name];
  }

  formatString(string) {
    const replacedCommas = string?.toString()?.replace(',', '.');
    return parseFloat(replacedCommas);
  }

  onSelectProduct(product) {
    let product_price_excl_vat = 0;

    if (!product?.is_one_time) {
      product_price_excl_vat =
        this.props.invoice?.direction === INVOICE_DIRECTIONS.INCOMING
          ? this.formatString(product.purchasePriceExclVat) || 0
          : this.formatString(product.salesPriceExclVat) || 0;
    }
    this.setState(
      {
        product,
        product_price_excl_vat_per_item: fixPriceFormat(product_price_excl_vat) || 0,
        showProductSelection: false,
        disableSave: true,
        showDefaultTasksModal: this.needToShowDefaultTasksConfirmation(product),
      },
      this.calculateFinancialAmounts.bind(this),
    );
  }

  needToShowDefaultTasksConfirmation(product) {
    return (
      this.props.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING &&
      !!this.props.vehicleId &&
      !!product.productTasks.length
    );
  }


  onConfirmTasksModalConfirmation(product) {
    this.setState({ applyDefaultTasks: true, showDefaultTasksModal: false });
  }

  onCancelTasksModalConfirmation(product) {
    this.setState({ applyDefaultTasks: false, showDefaultTasksModal: false });
  }

  onComplete(callback) {
    const product_price_excl_vat = stringToNumber(this.getFieldValue('product_price_excl_vat'));
    const product_price_incl_vat = stringToNumber(this.getFieldValue('product_price_incl_vat'));
    const product_price_excl_vat_per_item = stringToNumber(this.getFieldValue('product_price_excl_vat_per_item'));
    const product_price_incl_vat_per_item = stringToNumber(this.getFieldValue('product_price_incl_vat_per_item'));
    let one_time = this.getFieldValue('product')?.isOneTime == '1' ? this.getFieldValue('one_time') : null;
    one_time = stringToNumber(one_time);
    const data = {
      invoiceId: this.props.invoice.id,
      description: this.getFieldValue('description'),
      type: INVOICE_SUBJECT_TYPES.PRODUCT,
      vehicleId: this.props.vehicleId || null,
      product_id: this.getFieldValue('product')?.id,
      counter: this.getFieldValue('counter') || null,
      product_price_excl_vat,
      product_price_incl_vat,
      product_price_excl_vat_per_item,
      product_price_incl_vat_per_item,
      subjectVat: this.getFieldValue('subjectVat'),
      one_time,
      applyDefaultTasks: this.state.applyDefaultTasks,
    };

    if (this.props.editMode) {
      this.props.updateInvoiceSubject({ ...data }, res => {
        this.props.onClose();
      });
    } else {
      this.props.addInvoiceSubject({ ...data }, res => {
        this.props.onClose();
      });
    }
  }

  get financialAmountsDto() {
    const subject = {
      subject_type: INVOICE_SUBJECT_TYPES.PRODUCT,
      direction: this.props.invoice.direction,
      product_id: this.productId,
      vehicleId: this.props.vehicleId,
      incomingCompanyId: this.props.incomingCompanyId,
      outgoingCompanyId: this.props.outgoingCompanyId,
    };
    if (!this.productId) {
      subject.manuallyCreated = true;
      // subject.subjectId = this.props.currentSubject.id;
      subject.vatCode = this.props.currentSubject.subjectVat.vat.code;
    }
    const product_price_excl_vat_per_item = this.getFieldValue('product_price_excl_vat_per_item');
    subject.one_time = stringToNumber(this.getFieldValue('one_time'));

    if (subject.direction === INVOICE_DIRECTIONS.INCOMING) {
      subject.financialAmounts = { product_price_excl_vat_per_item };
    }

    if (subject.direction === INVOICE_DIRECTIONS.OUTGOING) {
      subject.salesAmounts = { product_price_excl_vat_per_item };
    }
    const vatCodeFromProduct =
      subject.direction === INVOICE_DIRECTIONS.INCOMING ? this.product?.vatIn : this.product?.vatOut;
    const vatCodeFromSubject = this.props.currentSubject?.subjectVat?.code;
    const vatCode = vatCodeFromSubject ?? vatCodeFromProduct;
    if (vatCode) subject.vatCode = vatCode;

    return subject;
  }

  get productId() {
    return this.state.product?.id || this.props.currentSubject?.product_id;
  }

  get product() {
    return this.state.product || this.props.currentSubject?.product;
  }

  get isWithQuantity() {
    return (
      this.state.product?.isOneTime == '1' ||
      this.props.currentSubject?.product?.isOneTime == '1' ||
      this.props.currentSubject?.one_time
    );
  }

  sanitizeValue(raw) {
    return raw === '' ? null : raw;
  }

  // calculateFinancialAmounts = () => {
  //   const pricePerItemExclVat = parseFloat(this.state.product_price_excl_vat_per_item) || 0;
  //   const quantity = parseFloat(this.state.one_time) || 1;
  //   const vatRate = parseFloat(this.state.vatRate) || 0;
  //   const totalExclVat = pricePerItemExclVat * quantity;
  //   const totalVat = totalExclVat * (vatRate / 100);
  //   const totalInclVat = totalExclVat + totalVat;
  //
  //   const vatPerItem = pricePerItemExclVat * (vatRate / 100);
  //   const pricePerItemInclVat = pricePerItemExclVat + vatPerItem;
  //
  //   this.setState({
  //     product_price_excl_vat: totalExclVat.toFixed(2),
  //     product_price_incl_vat: totalInclVat.toFixed(2),
  //     product_price_excl_vat_per_item: pricePerItemExclVat.toFixed(2),
  //     product_price_incl_vat_per_item: pricePerItemInclVat.toFixed(2),
  //     disableSave: false,
  //   });
  // };

  calculateFinancialAmounts() {
    this.props.calculateFinancialAmounts(this.financialAmountsDto, result => {
      if (result?.id) {
        delete result.id;
      }

      if (result?.invoiceId) {
        delete result?.invoiceId;
      }

      if (result?.subjectVat?.id) {
        delete result.subjectVat.id;
      }

      if (result?.description) {
        delete result.description;
      }

      result.product_price_excl_vat = result.product_price_excl_vat
        ? fixPriceFormat(result.product_price_excl_vat)
        : fixPriceFormat(0);
      result.product_price_incl_vat = result.product_price_incl_vat
        ? fixPriceFormat(result.product_price_incl_vat)
        : fixPriceFormat(0);
      delete result.costType;
      const one_time = stringToNumber(this.state.one_time) ?? 1;
      const origin_product_price_excl_vat = +fixPriceFormat(result.product_price_excl_vat / one_time || 0);

      const origin_product_price_incl_vat = +fixPriceFormat(result.product_price_incl_vat / one_time || 0);

      this.setState(prev => {
        return {
          ...prev,
          ...result,
          origin_product_price_excl_vat,
          origin_product_price_incl_vat,
          disableSave: false,
          one_time,
          origin_one_time: one_time,
        };
      });
    });
  }

  onSetFixedValue(name, value) {
    const roundValue = value ? parseFloat(value?.replace(',', '.')) : value;

    this.setState(
      prev => {
        return { ...prev, [name]: fixPriceFormat(roundValue), disableSave: true, initiate: false };
      },

      () => this.handleCalculateInputChange(name),
    );
  }

  onInputChange(evt) {
    const name = evt?.target?.name;
    const value = evt?.target?.value;
    if (!name) return;
    if (name == 'description') {
      return this.setState({ [name]: value, initiate: false });
    }
    if (['product_price_excl_vat_per_item'].includes(name)) {
      const enteredValue = value || '';
      if (getQuantOfDecimalPlaces(enteredValue) > 2) return;
      this.setState(
        prev => {
          return { ...prev, [name]: value, disableSave: true, initiate: false };
        },

        () => {
          if (value) {
            this._t = this.timeout(() => this.onSetFixedValue(name, value), 2500, this._t);
          }
        },
      );
      return;
    }

    this.setState(
      prev => {
        return { ...prev, [name]: value, disableSave: true, initiate: false };
      },
      () => this.handleCalculateInputChange(name),
    );
  }

  handleCalculateInputChange(name) {
    if (['product_price_excl_vat_per_item', 'one_time'].includes(name)) {
      name != 'one_time'
        ? this.setState({ priceTypeChanged: name, one_time: '1' }, () => {
            this._t = this.timeout(this.calculateFinancialAmounts.bind(this), 1000, this._t);
          })
        : this.setState({ priceTypeChanged: 'product_price_excl_vat_per_item' }, () => {
            this._t = this.timeout(this.calculateFinancialAmounts.bind(this), 1000, this._t);
          });
    }
  }

  get onCompleteDisabled() {
    const productId = this.getFieldValue('product')?.id;
    return this.state.disableSave || this.props.editDisabled;
  }
  renderModal() {
    return (
      <>
        {this.state.showDefaultTasksModal && <ProductDefaultTasksModalConfirmation
          onConfirm={this.onConfirmTasksModalConfirmation.bind(this)}
          onCancel={this.onCancelTasksModalConfirmation.bind(this)}
        />}
        <ModalComponent title={this.lbl('confirm')} onClose={this.props.onClose}>
          {/* {this.props.subjectModal && (
            <FormField>
              <VBox>
                <p>{this.lbl('invoice.subject.type')}</p>
                <Wrap>
                  <SearchSelect
                    options={this.props.subjectOptions}
                    value={this.props.type}
                    onChange={this.props.onChangeSubjectType}
                  />
                </Wrap>
              </VBox>
            </FormField>
          )} */}
          <FormField label={this.lbl('product')}>
            <HBox left vCenter>
              &nbsp;
              <ProductSelection
                vehicle={this.props.vehicle}
                currentSubject={this.props.currentSubject}
                vehicleId={this.props.vehicleId}
                invoice={this.props.invoice}
                onComplete={this.onSelectProduct.bind(this)}
                onClose={() => this.setState({ showProductSelection: false })}
                direction={this.props.invoice?.direction}
                companyId={this.props.companyId}
                taxRegion={this.props.taxRegion}
                vehiclePurpose={this.props.vehiclePurpose}
              />
            </HBox>
          </FormField>
          <br />
          <FormField label={this.lbl('product_price_excl_vat_per_item')}>
            <input
              className="form-control"
              disabled={this.props.editDisabled}
              type={'text'}
              name={'product_price_excl_vat_per_item'}
              placeholder={'Prijs per stuk excl. BTW'}
              value={this.getFieldValue('product_price_excl_vat_per_item')}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
          <br />

          <FormField label={this.lbl('product.one_time')}>
            <input
              className="form-control"
              disabled={this.props.editDisabled}
              type={'text'}
              name={'one_time'}
              placeholder={'Voer het aantal in'}
              value={this.getFieldValue('one_time')}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
          <br />

          <FormField label={this.lbl('product.total_price_excl_vat')}>
            <input
              className="form-control"
              disabled={this.props.editDisabled}
              type={'text'}
              name={'product_price_excl_vat'}
              placeholder={'Prijs totaal excl. BTW'}
              value={this.getFieldValue('product_price_excl_vat')}
            />
          </FormField>
          <br />
          <FormField label={this.lbl('product.total_price_incl_vat')}>
            <input
              className="form-control"
              disabled={this.props.editDisabled}
              type={'text'}
              name={'product_price_incl_vat'}
              placeholder={'Prijs totaal incl. BTW'}
              value={this.getFieldValue('product_price_incl_vat')}
            />
          </FormField>
          <br />

          <FormField label={this.lbl('product.description')}>
            <textarea
              style={{ width: '100%' }}
              disabled={this.props.editDisabled || this.props.invoice.isFinal}
              type={'text'}
              name={'description'}
              placeholder={'Product omschrijving'}
              value={this.getFieldValue('description')}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>

          <div className="mt-2 d-flex gap-2">
            <ButtonComponent
              style="ButtonSoftEdit"
              onClick={this.onComplete.bind(this, this.props.onComplete)}
              disabled={this.onCompleteDisabled}
            >
              {this.props.editMode ? this.lbl('update') : this.lbl('add')}
            </ButtonComponent>
            <ButtonComponent style="ButtonSoftDelete" onClick={this.props.onClose}>
              {this.lbl('cancel')}
            </ButtonComponent>
          </div>
        </ModalComponent>
      </>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;
    return this.renderModal();
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_ADD_INVOICE_SUBJECT),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addInvoiceSubject: (data, callback) => {
      dispatch(addInvoiceSubject(data, ownProps.invoice.id, callback));
    },
    updateInvoiceSubject: (data, callback) => {
      dispatch(updateInvoiceSubject(data, ownProps.invoice.id, ownProps.currentSubject.id, callback));
    },
    calculateFinancialAmounts(subject, callback) {
      if (!+subject?.vatCode && +subject?.vatCode != 0) {
        subject.vatCode = DEFAULT_VAT_CODE;
      }

      dispatch(calculateFinancialAmounts(subject, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductSubjectDetails = compose(withConnect, withRouter)(ProductSubjectDetailsComp);
